import { render } from "./stock-movements.vue?vue&type=template&id=38d9cbae&scoped=true"
import script from "./stock-movements.vue?vue&type=script&lang=js"
export * from "./stock-movements.vue?vue&type=script&lang=js"

import "./stock-movements.vue?vue&type=style&index=0&id=38d9cbae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d9cbae"]])

export default __exports__